const ScrollIcon = () => (
  <svg viewBox="0 0 64 64" fill="currentColor" width="100%" height="100%">
    <defs>
      <linearGradient id="parchment" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#c9a067"/>
        <stop offset="15%" stopColor="#f5deb3"/>
        <stop offset="85%" stopColor="#f5deb3"/>
        <stop offset="100%" stopColor="#d4a574"/>
      </linearGradient>
      <linearGradient id="scrollRoll" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#d4a574"/>
        <stop offset="30%" stopColor="#c9a067"/>
        <stop offset="70%" stopColor="#b8956a"/>
        <stop offset="100%" stopColor="#a08050"/>
      </linearGradient>
      <linearGradient id="featherGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6b4423"/>
        <stop offset="50%" stopColor="#4a3020"/>
        <stop offset="100%" stopColor="#2a1f1a"/>
      </linearGradient>
      <linearGradient id="inkGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#2a1a1a"/>
        <stop offset="100%" stopColor="#0a0505"/>
      </linearGradient>
      <filter id="scrollShadow">
        <feDropShadow dx="1" dy="1" stdDeviation="1" floodOpacity="0.3"/>
      </filter>
    </defs>
    
    {/* Pergaminho - lado esquerdo enrolado */}
    <ellipse cx="10" cy="32" rx="4" ry="22" fill="url(#scrollRoll)" filter="url(#scrollShadow)"/>
    <ellipse cx="10" cy="32" rx="2.5" ry="20" fill="#d4a574"/>
    <path d="M10 10 C12 10 14 12 14 14 L14 50 C14 52 12 54 10 54" fill="#c9a067"/>
    
    {/* Pergaminho principal */}
    <path d="M14 12 L14 52 L50 52 L50 12 Z" fill="url(#parchment)"/>
    
    {/* Textura do pergaminho */}
    <path d="M16 14 L48 14 L48 50 L16 50 Z" fill="#f5edd8" opacity="0.5"/>
    <path d="M18 16 Q32 18 46 16 Q32 20 18 16" fill="#e8dcc4" opacity="0.3"/>
    <path d="M18 48 Q32 46 46 48 Q32 44 18 48" fill="#d4c4a8" opacity="0.3"/>
    
    {/* Linhas de texto estilizadas como escrita medieval */}
    <g stroke="#5a4a3a" strokeLinecap="round" opacity="0.8">
      <path d="M20 20 Q24 19 28 20 Q32 21 38 20 L42 20" strokeWidth="1.5" fill="none"/>
      <circle cx="19" cy="20" r="1.5" fill="#8b2500"/>
      
      <path d="M20 26 Q26 25 32 26 Q36 27 40 26" strokeWidth="1.2" fill="none"/>
      
      <path d="M20 32 Q25 31 30 32 Q35 33 42 32" strokeWidth="1.2" fill="none"/>
      <circle cx="43" cy="32" r="1" fill="#1e3a8a"/>
      
      <path d="M20 38 Q28 37 36 38" strokeWidth="1.2" fill="none"/>
      
      <path d="M20 44 Q30 43 40 44 L44 44" strokeWidth="1.5" fill="none"/>
      <circle cx="19" cy="44" r="1.5" fill="#8b2500"/>
    </g>
    
    {/* Selo de cera */}
    <circle cx="42" cy="48" r="4" fill="#8b2500"/>
    <circle cx="42" cy="48" r="3" fill="#a03000"/>
    <circle cx="42" cy="48" r="2" fill="#b84000"/>
    <path d="M40 47 L42 46 L44 47 L44 49 L42 50 L40 49 Z" fill="#8b2500"/>
    
    {/* Pena (quill) detalhada */}
    <g transform="translate(44, 2)">
      {/* Haste da pena */}
      <path d="M6 8 L4 52 L6 54 L8 52 L6 8 Z" fill="url(#featherGrad)"/>
      <path d="M5.5 10 L5.5 50" stroke="#3a2a1a" strokeWidth="0.5"/>
      
      {/* Barbas da pena - lado esquerdo */}
      <path d="M6 8 Q0 4 -2 0 Q2 6 6 10" fill="#5c4033"/>
      <path d="M6 12 Q-1 8 -3 2 Q3 10 6 14" fill="#6b4423"/>
      <path d="M6 16 Q1 14 -2 8 Q4 14 6 18" fill="#5c4033"/>
      <path d="M6 20 Q2 18 0 14 Q4 18 6 22" fill="#6b4423"/>
      
      {/* Barbas da pena - lado direito */}
      <path d="M6 8 Q12 4 14 0 Q10 6 6 10" fill="#5c4033"/>
      <path d="M6 12 Q13 8 15 2 Q9 10 6 14" fill="#6b4423"/>
      <path d="M6 16 Q11 14 14 8 Q8 14 6 18" fill="#5c4033"/>
      <path d="M6 20 Q10 18 12 14 Q8 18 6 22" fill="#6b4423"/>
      
      {/* Ponta da pena */}
      <path d="M5 54 L6 60 L7 54 Z" fill="#1a0f0a"/>
    </g>
    
    {/* Gota de tinta */}
    <ellipse cx="52" cy="56" r="3" ry="2" fill="url(#inkGrad)"/>
    <circle cx="51" cy="55" r="0.5" fill="#3a2a2a"/>
  </svg>
)

export default ScrollIcon
